import React from 'react';
import { DevicePolicyHeading, DevicePolicyText, DevicePolicyContainer } from './styled';
import { Strings } from './strings';
import { DataTestAttributes } from './constants';
import { Components } from '../../common/interfaces';
import { getErrorMessage } from '../../utils/ErrorUtil';
import { parseMarkedDownText } from '../../utils/ContentUtil';
var DevicePolicy = function DevicePolicy(_ref) {
  var content = _ref.content,
    headingLevel = _ref.headingLevel,
    onError = _ref.onError;
  if (!content) return null;
  if (!content.heading || !content.policyText) {
    onError(getErrorMessage(Components.DEVICE_POLICY, "".concat(Strings.MISSING_CONTENT_ERROR)));
    return null;
  }
  var devicePolicyContent = content.policyText;
  var devicePolicyHeading = content.heading;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DevicePolicyContainer, {
    "data-test": DataTestAttributes.DEVICE_POLICY_WRAPPER
  }, /*#__PURE__*/React.createElement(DevicePolicyHeading, {
    "data-test": DataTestAttributes.DEVICE_POLICY_HEADING,
    "aria-level": headingLevel
  }, devicePolicyHeading), /*#__PURE__*/React.createElement(DevicePolicyText, {
    "data-test": DataTestAttributes.DEVICE_POLICY_TEXT,
    dangerouslySetInnerHTML: parseMarkedDownText(devicePolicyContent)
  })));
};
export default /*#__PURE__*/React.memo(DevicePolicy);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/DevicePolicy/index.js
// module id = 3973
// module chunks = 11